import { CACHE_TTL_MS } from "../constants/constants";

const _memoryStore = new Map();

export const cache = {
  read(key) {
    try {
      const raw = _memoryStore.get(key);
      if (!raw) return null;
      const parsed = JSON.parse(raw);
      if (!parsed?.expiresAt || Date.now() > new Date(parsed.expiresAt).getTime()) {
        _memoryStore.delete(key);
        return null;
      }
      return parsed;
    } catch {
      return null;
    }
  },
  write(key, data) {
    const now = new Date();
    const record = {
      data,
      lastUpdated: now.toISOString(),
      expiresAt: new Date(now.getTime() + CACHE_TTL_MS).toISOString(),
    };
    _memoryStore.set(key, JSON.stringify(record));
    return record;
  },
  clear(key) {
    if (key) _memoryStore.delete(key);
    else _memoryStore.clear();
  },
};